<template>
  <div>

  </div>
</template>

<script setup>

import { useAuthStore } from "@/stores/auth";
import router from "@/router";

const authStore = useAuthStore();

switch (authStore.user.role) {
  case 'admin':
    router.push({name: 'pages.admin.dashboard'});
  break;

  default:
    if(['attendee', 'buyer', 'exhibitor', 'sponsor', 'speaker', 'visitor'].includes(authStore.user.role)) {
      router.push({name: 'shared.dashboard'});
    }
    break;
}
</script>
